export const texts = {
  relayUrl: {
    description:
      'This is a short explanatory text about where can I get the url before pasting it in the input, or somehing else I need to know before entering the url'
  }
}
